<avd-styling-card-shell [label]="label" [inverseMode]="inverseMode">
    <div token-card-preview class="styling_swatch">
        <div
            class="elevated-preview"
            [style.background-color]="
                cssVariableName ? 'var(' + cssVariableName + ')' : 'transparent'
            "
            [style.box-shadow]="
                boxShadowCssVariableName
                    ? 'var(' + boxShadowCssVariableName + ')'
                    : 'none'
            "
            [class.elevated-preview--inverse]="inverseMode"
        >
            <uilab-mat-form-field
                appearance="outline"
                class="elevated-preview__field"
            >
                <uilab-mat-label>Example input</uilab-mat-label>
                <input
                    uilabMatInput
                    type="text"
                    value="Elevated container"
                    aria-label="Example input"
                />
            </uilab-mat-form-field>

            <div class="elevated-preview__actions">
                <button uilabMatButton="text" type="button">Cancel</button>
                <button uilabMatButton="filled" type="button">Next</button>
            </div>
        </div>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        title="Container color variable"
        [snippet]="containerColorVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>

    <avd-css-variable-snippet
        token-card-snippets
        title="Box shadow variable"
        [snippet]="boxShadowVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
